<div class="page-holder">

  <div class="cards-holder">
    <h3>Twoje karty</h3>
    @if (cards && cards.length) {
      <div class="cards-items-holder">
        @for (card of cards; track card) {
          <div class="card-list-item">
            <app-card-preview [active]="card.status >= 2 && card.status < 6 " [card]="card"></app-card-preview>
            @if (cardStats.get(card.id); as stats) {
              <div class="card-stats">
                @for (p of stats.partners; track p) {
                  <div class="card-stats-partner">
                    <div class="card-stats-partner-name">
                      {{ p.partner_id === 0 ? 'Punkty ZGranego Grona' : p.partner_name }}
                    </div>
                    <div class="card-stats-chips">
                      <span class="card-stat-chip card-stat-chip--score">
                        <mat-icon>star</mat-icon> {{ p.total_score }} pkt
                      </span>
                      @if (p.partner_id !== 0) {
                        <span class="card-stat-chip">
                          <mat-icon>payments</mat-icon> {{ p.total_amount }} zł
                        </span>
                      }
                      @if (p.entry_count > 0) {
                        <span class="card-stat-chip">
                          <mat-icon>login</mat-icon> {{ p.entry_count }} wejść
                        </span>
                      }
                      @if (p.transaction_count > 0) {
                        <span class="card-stat-chip">
                          <mat-icon>receipt</mat-icon> {{ p.transaction_count }} transakcji
                        </span>
                      }
                      @if (p.product_count > 0) {
                        <span class="card-stat-chip">
                          <mat-icon>redeem</mat-icon> {{ p.product_count }} nagród
                        </span>
                      }
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    } @else {
      <p>Brak kart do wyświetlenia.</p>
      <small>Uzupełnij brakujące dane, aby móc zamówić kartę.</small>
    }
  </div>
  <div class="persons-holder">
    <h3>Twoja Rodzina</h3>
    @if (person) {
      <div>
        <table class="family-table mat-elevation-z1">
          <thead>
            <tr>
              <th>Imię i Nazwisko</th>
              <th>Posiada kartę</th>
              <th>Akcje</th>
            </tr>
          </thead>
          <tbody>
            <!-- Parent row -->
            <tr>
              <td>{{ person.name }} {{ person.surname }}</td>
              <td>
                @if (hasCardFor(person.id)) {
                  <mat-icon color="primary" title="Ma przypisane karty">
                    credit_card
                  </mat-icon>
                }
                @if (!hasCardFor(person.id)) {
                  <span style="color: #888;">
                    Brak karty
                  </span>
                }
              </td>
              <td>
                @if (!hasCardFor(person.id) && ((person.type === 'CHILDREN' && person.children && person.children.length > 0) || person.type !== 'CHILDREN')) {
                  <button
                    class="custom-button" (click)="orderCard(person)" >
                    Zamów kartę
                  </button>
                }
              </td>
            </tr>
            <!-- Children rows -->
            @for (child of person.children; track trackByChildId($index, child)) {
              <tr>
                <td>{{ child.name }} {{ child.surname }}</td>
                <td>
                  @if (hasCardFor(child.id)) {
                    <mat-icon color="primary" title="Ma przypisane karty">
                      credit_card
                    </mat-icon>
                  }
                  @if (!hasCardFor(child.id)) {
                    <span style="color: #888;">
                      Brak karty
                    </span>
                  }
                </td>
                <td>
                  @if (!hasCardFor(child.id) && ((person.type === 'CHILDREN' && person.children && person.children.length > 0) || person.type !== 'CHILDREN')) {
                    <button
                      class="custom-button" (click)="orderCard(child)" >
                      Zamów kartę dziecka
                    </button>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
        @if (false && person.type === 'SENIOR') {
          <div>
            <form [formGroup]="seniorForm" (ngSubmit)="onSubmit()">
              <h3>Powiąż swoją kartę z kartami wnuków</h3>
              <p>Jeśli jesteś seniorem, możesz powiązać swoją kartę z kartami swoich wnuków, aby skorzystać z dodatkowych zniżek i korzyści oferowanych przez program. Wprowadź numery kart swoich wnuków w poniższym polu, oddzielając je przecinkami.
              </p>
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Numery Kart wnuków</mat-label>
                <input matInput formControlName="complementary" minlength="3" />
                @if (seniorForm.get('complementary')?.hasError('pattern')) {
                  <mat-error>
                    Wpisz numery kart wnuków przedzielone przecinkami (np. 123,456,789)
                  </mat-error>
                }
                @if (seniorForm.get('complementary')?.hasError('minlength')) {
                  <mat-error>
                    Wpisz co najmniej 3 znaki
                  </mat-error>
                }
                @if (seniorForm.get('complementary')?.hasError('required')) {
                  <mat-error>
                    To pole jest wymagane
                  </mat-error>
                }
              </mat-form-field>
              <!-- Submit Button -->
              <button class="custom-button" mat-raised-button color="primary" type="submit" [disabled]="seniorForm.invalid || submitting">
                {{ submitting ? 'Zapisywanie...' : 'Zapisz zmiany' }}
              </button>
            </form>
          </div>
        }
        <!-- Debug info -->
        <!--
        <div class="debug-info" style="margin-top: 10px; padding: 10px; background: #f5f5f5; border-radius: 4px;">
          <p><strong>Debug Info:</strong></p>
          <p>Person ID: {{ person.id }}</p>
          <p>Person Name: {{ person.name }} {{ person.surname }}</p>
          <p>Children Count: {{ person.children?.length || 0 }}</p>
          <p>Children Data: {{ person.children | json }}</p>
        </div>
        -->
      </div>
    } @else {
      <p>Brak danych o osobie do wyświetlenia.</p>
    }

  </div>

</div>